const _ = require('lodash');

class RecipeCategoriesService {
    constructor(restangular, $q, bootstrap) {
        this.$q = $q;

        this._api = restangular.all('recipeCategories');

        this.categories = [];
        this.currentCategory = {};

        if (bootstrap.isBootstrapped(bootstrap.bootstrapped.RecipeCategories)) {
            this.setAll(bootstrap.getBootstrappedData(bootstrap.bootstrapped.RecipeCategories));
        }
    }

    getAll() {
        if (this.categories.length > 0) {
            return this.$q.when(this.categories);
        }

        return this._api.getList().then(this.setAll.bind(this));
    }

    setAll(categories) {
        this.categories = categories;
        this.resetCurrentCategory();

        return categories;
    }

    resetCurrentCategory() {
        this.currentCategory = {};
    }

    setCategoryByName(aisleName, categoryName) {
        this.currentCategory = this.getCategoryByName(aisleName, categoryName);
    }

    getCategoryByName(aisleName, categoryName) {
        const department = _.find(this.categories, category => category.UrlFriendlyName === aisleName);
        const aisle = department
            ? _.find(department.ChildCategories, childCategory => childCategory.UrlFriendlyName === categoryName)
            : {};

        return {
            department: department || {},
            aisle,
        };
    }

    hasCurrentCategory() {
        return !!(this.currentCategory && this.currentCategory.aisle && this.currentCategory.department);
    }
}

module.exports = RecipeCategoriesService;



// WEBPACK FOOTER //
// ./src/recipe/recipe-categories.service.js